import styled from "styled-components"
import { Container } from "../../styles/Container"

export const Wrapper = styled.div`
  background-color: var(--footer-color);
`

export const Content = styled.div`
  ${Container}
  margin: 0 auto;
  padding-top: 5rem;
  padding-bottom: 5rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  align-items: center;
  @media (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
    text-align: center;
  }

  .SocialLinks {
    margin: 5px;
    display: flex;
    flex-direction: row;

    @media (max-width: 576px) {
        justify-content: center;
    }
    a {
      margin: 8px;
      font-size: 28px;
      :hover {
        color: #191970;
      }
    }
  }
`

export const CopyRight = styled.p`
  color: var(--footer-scnd);
  font-size: 1rem;
  margin-top: 2rem;
  align-items: left;
  justify-content: center;
  text-align: right;
  @media (max-width: 576px) {
    text-align: center;
  }
`
